import { getListingDocumentOverallStatus } from '../../../helpers/listingDocumentStatusFilter';

export const countListingsPendingDocumentReview = (listings) => (
  (listings || []).filter(
    (listing) => getListingDocumentOverallStatus(listing) === 'pending'
  ).length
);

export const getListingTitle = (listing) => {
  if (listing && listing.title) return listing.title;
  const itemName = listing
    && listing.settingsData
    && listing.settingsData[0]
    && listing.settingsData[0].listsettings
    && listing.settingsData[0].listsettings.itemName;
  const city = listing && listing.city;
  if (itemName && city) return `${itemName} in ${city}`;
  return itemName || city || '-';
};

export const formatStreetAddress = (listing) => {
  if (!listing) return '-';
  const parts = [listing.street, listing.buildingName, listing.zipcode].filter(Boolean);
  return parts.length ? parts.join(', ') : '-';
};
